// extracted by mini-css-extract-plugin
export default {"scroll_list_container":"scrollList_scroll_list_container__1wcLU","scroll_list":"scrollList_scroll_list__X2wVC"};